import { zodTransformFirestoreTimestampToDate } from "../utils/zodUtils.mjs";
import { zodFlavorId } from "./ids.mjs";
import { defineFirestoreCollection } from "./firebaseCollectionSchema.mjs";
import { z as z$1 } from "zod";

// src/models/claimsRefresh.ts
const claimsRefreshSchema = z$1.object({
	id: zodFlavorId(),
	updatedAt: z$1.any().transform(zodTransformFirestoreTimestampToDate)
});
/**
* Claims refresh collection definition
* Path: claims_refresh/{userId}
*/
const ClaimsRefresh = defineFirestoreCollection("claims_refresh", claimsRefreshSchema);

export { ClaimsRefresh, claimsRefreshSchema };
//# sourceMappingURL=claimsRefresh.mjs.map